export default __webpack_public_path__ + "static/media/logo.2ab5afa8.svg";